const theme = {
  tealGreen: '#00917A',
  fontFamily: "'Fira Sans',sans-serif",
  darkJungleGreen: '#0C423B',
  seafoamGreen: '#F0F8F7',
  brightYellow: '#FCD783',
  rosyPink: '#FB9A99',
  paleRobinEggBlue: '#9CD9DD',
  sherbertOrange: '#F2812E',
  cerulean: '#53BBC9',
};

export default theme;
